<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditDialog="openEditDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <EditForm
      v-if="editFormOpts.visible"
      ref="editForm"
      :type="editFormOpts.type"
      :visible.sync="editFormOpts.visible"
      :amzControlParamsCode="editFormOpts.amzControlParamsCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import EditForm from '../edit-form'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditForm },
  data() {
    return {
      usePage: true,
      editFormOpts: { visible: false, amzMarketCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzPriceControlParamsListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, data = {} }) {
      const { amzControlParamsCode = '' } = data
      this.editFormOpts = { visible: true, type, amzControlParamsCode }
    },
  },
}
</script>
